// 意见反馈顶部筛选tab
export let orderTabLabels = [
  {
    label: '提交时间',
    type: 'time-slot',
    value: 'createdDate',
    startName: 'createdDateStart',
    endName: 'createdDateEnd',
    clearable: true
  }
]

// 意见反馈表头
export let tableLabels = [
  {
    label: '姓名',
    value: 'name'
  },
  {
    label: '电话号码',
    value: 'mobile'
  },
  {
    label: '邮箱',
    value: 'email'
  },
  {
    label: '提交时间',
    value: 'createdDate'
  }
]
